module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Line-7983ab374484f021c93a6a2a421b45f8.svg";